import React from 'react'

class BoldText extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11">
        <path
          fill="#343638"
          fillRule="evenodd"
          d="M5.515.59c2.479.01 3.718.91 3.718 2.7 0 .587-.177 1.081-.53 1.483-.354.402-.875.655-1.562.758v.015c.774.099 1.36.357 1.76.777.4.419.599.941.599 1.568 0 .867-.318 1.534-.954 2-.636.466-1.568.7-2.794.7H.5v-10h5.015zm-.221 5.954H3.088v2.212h2.206c.478 0 .84-.096 1.088-.288.246-.193.37-.469.37-.829 0-.355-.124-.626-.37-.813-.247-.188-.61-.282-1.088-.282zM5.027 2.5h-1.94V4.68h1.94c.967 0 1.453-.363 1.458-1.088 0-.725-.486-1.09-1.458-1.094z"
        />
      </svg>
    )
  }
}

export default BoldText
